(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["mpac-home"] && !Shopify.designMode) return;
  try {
    
  function initializeHomeVideos(root) {
    root.querySelectorAll('[data-home-video]').forEach((video) => {
      if (video.dataset.initialized) return;
      video.dataset.initialized = 'true';
      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (reducedMotion || navigator.connection?.saveData) return;
      const startVideo = () => {
        video.muted = true;
        video.play().catch(() => {});
      };
      if ('IntersectionObserver' in window) {
        const observer = new IntersectionObserver((entries) => {
          if (!entries.some((entry) => entry.isIntersecting)) return;
          observer.disconnect();
          if (video.paused && video.currentTime === 0) startVideo();
        }, { threshold: 0.15 });
        observer.observe(video);
      } else {
        startVideo();
      }
    });
  }
  initializeHomeVideos(document);
  document.addEventListener('shopify:section:load', (event) => initializeHomeVideos(event.target));

  } catch(e) { console.error(e); }
})();
})();
